
export enum Compare {
    Equal = 0,
    NotEqual = 1,
    Greater = 2,
    GreaterOrEqual = 3,
    Less = 4,
    LessOrEqual = 5,
    Like = 6,
    LikeStartWith = 7,
    LikeEndWith = 8,
    NotLike = 9,
    NotLikeStartWith = 10,
    NotLikeEndWith = 11,
    Is = 12,
    IsNot = 13,
    In = 14,
    NotIn = 15
}

export enum FilterRelation {
    Empty = 0,
    And = 1,
    Or = 2
}

export interface FilterCondition {
    filterField: string;
    value: string;
    lbracket?: string;
    rbracket?: string;
    relation?: FilterRelation;
    compare?: Compare;
    expresstype?: ExpressValueType;
}

/** å¼ç±»å */
export enum ExpressValueType {
    Value = 0,    // å¼
    Expression = 1, // è¡¨è¾¾å¼
    FrontExpress = 'frontExpress'
}


export const LeftBracket = [
    '', '(', '((', '((('
];

export const RighttBracket = [
    '', ')', '))', ')))'
];

export const Relation = [
    { label: '', value: 0},
    { label: 'å¹¶ä¸', value: 1},
    { label: 'æè', value: 2}
];

export const CompareOperators = [
    { label: '=', value: 0},
    { label: '<>', value: 1},
    { label: '>', value: 2},
    { label: '>=', value: 3},
    { label: '<', value: 4},
    { label: '<=', value: 5},
    { label: 'like %...%', value: 6},
    { label: 'like ...%', value: 7},
    { label: 'like %...', value: 8},
    { label: 'not like %...%', value: 9},
    { label: 'not like ...%', value: 10},
    { label: 'not like %...', value: 11},
    { label: 'is', value: 12},
    { label: 'is not', value: 13},
    { label: 'in', value: 14},
    { label: 'not in', value: 15},
];

